module.exports = __webpack_public_path__ + "fonts/HelveticaNowDisplay-Regular.111b63d42130007cb8cc0e1060a45ac0.woff";